<template>
  <div class="qrCode">
    <div ref="qrCodeStr"></div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  name: "QrCodeGenerator",
  props: {
    // 二维码的值
    qrcodeValue: {
      type: String,
      required: true
    },
    // 二维码的宽度
    width: {
      type: Number,
      default: 200
    },
    // 二维码的高度
    height: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    this.generateQrCode();
  },
  watch: {
    qrcodeValue() {
      this.generateQrCode();
    }
  },
  methods: {
    generateQrCode() {
      if (this.qrcodeValue) {
        // 清除之前的二维码
        this.$refs.qrCodeStr.innerHTML = "";
        // 生成新的二维码
        new QRCode(this.$refs.qrCodeStr, {
          text: this.qrcodeValue,
          width: this.width,
          height: this.height,
          correctLevel: QRCode.CorrectLevel.H
        });

        // 如果需要，可以在这里添加文本标签
        // this.$refs.qrCodeStr.textContent = this.qrcodeValue
      }
    }
  }
};
</script>

<style scoped lang="less">
.qrCode {
  display: flex;
  text-align: center;
}
</style>
